const { ExIcon, TickIcon, BlackCard, BlueCard } = window.config.Statics;
const MIN_WIDTH_MOBILE = 1280;
export function drawSegments(Titles, Styles, Combos, Counter, IdWall) {
  let hasError = false;
  const $segmentStyles = document.querySelector("#wall");
  const $segment = document.getElementById("segments");
  const $segmentContainer = $segment.cloneNode(true);
  try {
    const isThankWall = window.LN.PaywallHub.idWall.toLowerCase() == "s_1";
    const $segmentTitle = $segmentContainer.querySelector(
      ".wall-encabezado h1.title span#mainTitle"
    );
    const $segmentSubTitle = $segmentContainer.querySelector(
      ".wall-encabezado h1.title span#subTitle"
    );
    const $cards = $segmentContainer.querySelector("#paywall-cards");

    if (Styles) {
      $segmentStyles.dataset.styles = Styles;
    }

    // Counter
    if (Counter) {
      const $counetLabel = $segmentContainer.querySelector("#TimeCounterLabel");
      const $counterRemainingTime = $segmentContainer.querySelector(
        "#remaining-time__time"
      );
      const { FinalDate, Message } = Counter;
      if (FinalDate && Message) {
        $counetLabel.dataset.message = Message;
        $counterRemainingTime.dataset.remainingTime = FinalDate;
      }
    }
    // Titulos
    $segmentTitle.innerHTML = Titles.Title;
    $segmentSubTitle.innerHTML = Titles.SubTitle;

    // Cards
    $cards.classList.remove("paywall-cards-3");
    $cards.classList.add(`paywall-cards-${Combos.length}`);
    const cardTemplate = $cards.querySelector("article");
    $cards.innerHTML = "";
    const fragment = document.createDocumentFragment();

    for (const [comboIndex, combo] of Combos.entries()) {
      const comboId = comboIndex + 1;
      const {
        ComboType,
        Recommended,
        IsRecomended,
        ButtonText,
        ProductName,
        SalesPlans,
        Benefist,
        Description,
      } = combo;
      let hasTitleShowBlueCard =
        Description.toLowerCase().includes("premium") ||
        Description.toLowerCase().includes("club");
      let hasTitleShowBlackCard = Description.toLowerCase().includes("black");
      const cardArticle = cardTemplate.cloneNode(true);
      cardArticle.setAttribute("id", `combo-${comboId}`);
      cardArticle.dataset.testId = `combo-${comboId}`;

      const isFree = ComboType == 0;
      let typeCombo = "default";
      const $features = cardArticle.querySelector(".fixed-features");

      const $titleCard = cardArticle.querySelector(".card-content-info-text");
      const $headerCard = cardArticle.querySelector("#header-1");
      const $firstPrice = cardArticle.querySelector(
        ".card-content-info-price .card-content-info-price-value"
      );
      const $thirdPrice = cardArticle.querySelector(
        ".card-content-info-price .card-content-info-price-note"
      );
      const $firstPriceDuration = cardArticle.querySelector(
        ".card-content-info-price .card-content-info-price-duration"
      );
      const $seconStep = cardArticle.querySelector(
        ".card-content-info-price .card-content-info-price-real-price"
      );
      const $buttonSuscribe = cardArticle.querySelector(
        "#button-suscribe-combo-1"
      );
      const $showMoreBenefist = cardArticle.querySelector(
        ".tab-label.tab-label-desk"
      );
      const $showMoreBenefistMobile = cardArticle.querySelector(
        ".tab-label.tab-label-mobile"
      );
      if (isFree) {
        typeCombo = ProductName.toLowerCase();
      } else if (IsRecomended) {
        typeCombo =
          IdWall === "F_2" || IdWall === "F_1"
            ? "recomendadoFamiliar"
            : "recomendado";
      }
      cardArticle.setAttribute("class", "");
      cardArticle.classList.add(
        "combo",
        comboTypes[ComboType] ?? comboTypes[1]
      );

      $headerCard.setAttribute("class", "");
      if (typeCombo) {
        cardArticle.classList.add(typeCombo);
        $headerCard.classList.add(
          isThankWall ? "recomendado__msg" : `${typeCombo}__msg`
        );
      }

      $headerCard.innerHTML = Recommended;

      $titleCard.firstElementChild.textContent = ProductName;
      if (hasTitleShowBlackCard || hasTitleShowBlueCard) {
        const targetImage = document.createElement("img");
        targetImage.alt = "Ilustración de tarjeta";
        targetImage.width = 40;
        targetImage.classList.add("img-onecard");

        if (hasTitleShowBlueCard) {
          targetImage.src = BlueCard;
        } else if (hasTitleShowBlackCard) {
          targetImage.src = BlackCard;
        }
        if ($titleCard.lastElementChild.tagName === "IMG") {
          $titleCard.replaceChild(targetImage, $titleCard.lastElementChild);
        } else {
          $titleCard.appendChild(targetImage);
        }
      }
      let firstPriceValue = 0;
      let firstPriceUnitOfTime = "";

      firstPriceUnitOfTime =
          SalesPlans?.[0]?.MonthsOfDiscount > 0
            ? `Durante ${SalesPlans[0].MonthsOfDiscount} ${SalesPlans?.[0]?.MonthsOfDiscount == 1 ? "mes" : "meses"
            }`
            : "Sin suscripción digital";
        firstPriceValue =
          SalesPlans?.[0]?.Price?.toLocaleString("de-DE") ?? 0;

      $firstPriceDuration.innerHTML = firstPriceUnitOfTime;
      $firstPrice.innerHTML = firstPriceValue;
      $firstPrice.dataset.testId = SalesPlans.length === 0 ? "precio-gratis" : "precio"
      const seconStep = SalesPlans[0]?.Steps?.find((sp) => sp.Etapa == 2);
      const thirdStep = SalesPlans[0]?.Steps?.find((sp) => sp.Etapa == 3);

      if (seconStep) {
        const seconStepPrice = calculateDiscout(
          seconStep.TiposDeDescuento,
          SalesPlans[0].PriceWithOutDiscount,
          seconStep.DescuentoProducto
        );
        $seconStep.innerHTML = `Luego $${seconStepPrice.toLocaleString(
          "de-DE"
        )} por ${seconStep.CantidadDeDespacho > 1
          ? seconStep.CantidadDeDespacho + " meses"
          : "mes"
          }`;
      }
      if (thirdStep) {
        $thirdPrice.innerHTML = `Finalizada la promo, el precio final será $${SalesPlans[0].PriceWithOutDiscount.toLocaleString(
          "de-DE"
        )} por mes`;
        $thirdPrice.setAttribute("style", "display: flex;");
        $thirdPrice.classList.remove('hidden-price');
      } else {
        $thirdPrice.classList.add('hidden-price');
      }

      $buttonSuscribe.disabled = isFree;
      $buttonSuscribe.innerHTML = ButtonText;
      $buttonSuscribe.dataset.combo = SalesPlans[0]?.Id;
      $buttonSuscribe.dataset.price = SalesPlans[0]?.Price;
      $buttonSuscribe.dataset.name = SalesPlans[0]?.Name;
      $buttonSuscribe.dataset.skn = getSKN(ProductName, ComboType);
      $buttonSuscribe.dataset.familyName = SalesPlans[0]?.ProductFamily;

      $features.innerHTML = "";

      if (Benefist) {
        $buttonSuscribe.dataset.containclub = Benefist.some(
          (b) => b.Description.toLowerCase().includes("club") && b.Enabled
        );
        for (const [indexOf, benefist] of Benefist.entries()) {
          const featureLi = document.createElement("li");
          const iconDiv = document.createElement("div");
          const iconImage = document.createElement("img");
          const description = document.createElement("p");

          description.textContent = benefist.Description;
          featureLi.setAttribute("id", `feature-${indexOf}`);
          featureLi.setAttribute(
            "class",
            "fixed-features-container tab-content-check reverse-icons"
          );
          if ((indexOf > 2 || window.innerWidth <= MIN_WIDTH_MOBILE) && !isThankWall) {
            featureLi.classList.add("hide");
          }
          iconDiv.setAttribute("class", "fixed-features-icons");

          iconImage.src = benefist.Enabled ? TickIcon : ExIcon;
          iconImage.width = 20;
          iconImage.alt = "icono de check";
          if (benefist.Enabled) iconImage.setAttribute("class", "check-icon");

          if (isThankWall) {
            const iconThanksImage = document.createElement("img");
            iconThanksImage.src = indexOf === 0 ? TickIcon : ExIcon;
            iconThanksImage.width = 20;
            iconThanksImage.alt = "icono de gracias";
            iconDiv.appendChild(iconThanksImage);
          }

          iconDiv.appendChild(iconImage);
          featureLi.appendChild(iconDiv);
          featureLi.appendChild(description);
          $features.appendChild(featureLi);
        }
      }
      if ($showMoreBenefist) {
        $showMoreBenefist.onclick = () => {
          toggleFeature(`combo-${comboId}`, false);
        };
      }
      if ($showMoreBenefistMobile) {
        $showMoreBenefistMobile.onclick = () => {
          toggleFeature(`combo-${comboId}`, true);
        };
      }
      fragment.appendChild(cardArticle);
    }
    $cards.append(fragment);
  } catch (err) {
    hasError = true;
    DD_LOGS?.logger?.error("Error dibujando el wall", err);
    console.log(err);
  } finally {
    if (!hasError) {
      $segment.replaceWith($segmentContainer);
    }
  }
}

function toggleFeature(comboId, isMobile) {
  const features = document.querySelectorAll(`#${comboId} .fixed-features li`);
  const label = document.querySelector(
    `#${comboId} .${isMobile ? "tab-label-mobile" : "tab-label-desk"}`
  );

  label.classList.toggle("open");
  label.querySelector("span").innerHTML = label.classList.contains("open")
    ? "Ver Menos"
    : "Conocer más";

  for (let feature of features) {
    feature.classList.toggle("hide");
  }
}
export function calculateDiscout(
  tipoDeDescuento,
  precioDefault,
  descuentoProducto
) {
  let result = 0;
  if (tipoDeDescuento === "DescuentoPorcentual") {
    result =
      descuentoProducto == 0
        ? precioDefault
        : precioDefault - (precioDefault * descuentoProducto) / 100;
  }
  if (tipoDeDescuento == "PrecioFijo") result = descuentoProducto;
  return result;
}

const comboTypes = [
  "gratis",
  "acc-digital",
  "acc-con-club",
  "acc-nyt",
  "tengo-club",
  "acc-duo",
  "acc-trio",
  "acc-familiar",
  "acc-digital",
  "acc-digital",
];

export function getSKN(wallName, comboType) {
  const combos = {
    foodit: { 1: "F", 2: "FC" },
    ln: { 1: "L", 2: "LC" },
    gracias: { 2: "gracias" },
  };

  for (const key in combos) {
    if (wallName.toLowerCase().includes(key) && combos[key][comboType]) {
      return combos[key][comboType];
    }
  }

  return "";
}



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/segmentos.js